// test1868
(1868 && 0);
